<template>
  <div class="heroesLeaderboard">
    <div class="hero_box">
      <el-table :data="tableData.slice((pageParams.page - 1) * pageParams.size, pageParams.page * pageParams.size)"
        style="
                  width: 100%;
                  flex: 1;
                  border: 1px solid #f2f4f7;
                  border-radius: 4px;margin-top: 30px;
              " size="medium" :header-cell-style="{
                fontWeight: 'normal',
                color: '#333',
                background: '#f5f7fa',
              }" class="table-content" :cell-style="{ fontSize: '12px', color: '#333' }">
        <el-table-column label="排名" align="center">
          <template slot-scope="scope">
            <div v-if="scope.$index <= 2"
              style="width: 100%;height: 100%;display: flex;align-items: center;justify-content: center;">
              <img v-if="scope.$index == 0" style="width: 26px;height: 26px;" src="@/assets/img/image/number1.png"
                alt="">
              <img v-if="scope.$index == 1" style="width: 26px;height: 26px;" src="@/assets/img/image/number2.png"
                alt="">
              <img v-if="scope.$index == 2" style="width: 26px;height: 26px;" src="@/assets/img/image/number3.png"
                alt="">
            </div>
            <span v-else> {{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="头像">
          <template slot-scope="scope">
            <div class="img_box">
              <img v-if="!scope.row.s_ico" src="../../assets/images/user_img.png" alt="">
              <img v-else :src="scope.row.s_ico" alt="">
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="s_account" label="学号">
        </el-table-column>
        <el-table-column prop="s_name" label="姓名">
        </el-table-column>
        <el-table-column prop="s_sex" label="性别">
          <template slot-scope="scope">
            {{ scope.row.s_sex ? scope.row.s_sex : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="detail_scores.attitude_score" label="态度得分">
          <template slot-scope="scope">
            <el-link v-if="role == 3" type="primary" @click="getDetial(1,scope.row)">{{
              scope.row.detail_scores.attitude_score }}</el-link>
            <span v-else>{{ scope.row.detail_scores.attitude_score }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="detail_scores.knowledge_score" label="知识得分">
          <template slot-scope="scope">
            <el-link v-if="role == 3" type="primary" @click="getDetial(2,scope.row)">{{
              scope.row.detail_scores.knowledge_score }}</el-link>
            <span v-else>{{ scope.row.detail_scores.knowledge_score }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="detail_scores.practice_score" label="技能得分">
          <template slot-scope="scope">
            <el-link v-if="role == 3" type="primary" @click="getDetial(3,scope.row)">{{
              scope.row.detail_scores.practice_score }}</el-link>
            <span v-else>{{ scope.row.detail_scores.practice_score }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="detail_scores.literacy_score" label="素养得分">
          <template slot-scope="scope">
            <el-link v-if="role == 3" type="primary" @click="getDetial(4,scope.row)">{{
              scope.row.detail_scores.literacy_score }}</el-link>
            <span v-else>{{ scope.row.detail_scores.literacy_score }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="comp_score" label="综合得分">
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination :current-page="pageParams.page" :page-size="pageParams.size"
          @current-change="handleCurrentChange" background layout="prev, pager, next, total" :total="tableData.length">
        </el-pagination>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  data() {
    return {
      tableData: [],
      pageParams: {
        page: 1,
        size: 10,
        paging: 1,
        total: 0,
      },
      total: 0,
      role: 0
    };
  },
  methods: {
    handleCurrentChange(val) {
      this.pageParams.page = val;
    },
    getTableData() {
      let params = {
        course_id: Number(this.$route.query.course_id),
        class_id:
          Number(localStorage.getItem("class_id")) ||
          Number(localStorage.getItem("c_id")),
        course_chapter: Number(localStorage.getItem("teacherChapter")) || Number(localStorage.getItem("studentChapter")),
        course_node: Number(localStorage.getItem("teacherNode")) || Number(localStorage.getItem("studentNode"))
      };
      this.$shttp.axiosPost(
        this.$api.jdCourseRankingGetRanking,
        params,
        (res) => {
          if (res.code === 200) {
            this.tableData = res.data;
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        },
        (err) => {
          const errorData = err.response.data;
          this.$message.error(errorData.msg);
        }
      );
    },
    getDetial(type,row) {
      switch (type) {
        case 1:
          // 态度
          this.$router.push({ path: "/qualityCourse/leaderBoardDetial/attidute", query: {s_id:row.s_id, ...this.$route.query } })
          break;
        case 2:
          // 知识
          this.$router.push({ path: "/qualityCourse/leaderBoardDetial/knowledge", query: { s_id:row.s_id,...this.$route.query } })

          break;
        case 3:
          // 技能
          this.$router.push({ path: "/qualityCourse/leaderBoardDetial/skill", query: { s_id:row.s_id,s_name:row.s_name,s_ico:row.s_ico,...this.$route.query } })

          break;
        case 4:
          // 素养
          this.$router.push({ path: "/qualityCourse/leaderBoardDetial/literacy", query: {s_id:row.s_id, ...this.$route.query } })

          break;
      }

    }
  },
  mounted() {
    this.getTableData();
    this.role = localStorage.getItem("role")
  },
};
</script>
<style lang="scss" scoped>
.heroesLeaderboard {
  width: 100%;
  height: 100%;
  background: #fff;

  .hero_box {
    padding: 10px 20px;
    box-sizing: border-box;

    .pagination {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 50px;
      margin-top: 30px;
    }
  }
}

.img_box {
  width: 30px;
  height: 30px;
  border-radius: 100%;

  img {
    width: 100%;
    height: 100%;
    border-radius: 100%;
    object-fit: cover;
  }
}
</style>